import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

const initialState = {
    jokes: [],
    favorites: []
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case "SET_JOKES": 
            return {...state, jokes: action.payload}
        case "ADD_FAVORITE":
            if(!state.favorites.find(({setup}) => setup === action.payload.jokes.setup)) {
                const newFav = state.favorites.concat(action.payload.jokes)
                return {...state, favorites: newFav}
            }
        default:
            return state
    }
}

const store = createStore(reducer, applyMiddleware(thunk))

export default store